import React from "react"
import { jsonClone } from "../../../../../utils/json"
import CheckboxFilterItem from "../CheckboxFilterItem"
import { CheckboxFilterOption, FilterCategory } from "../types"

interface Props {
  item: FilterCategory
  onItemUpdate: (item: FilterCategory) => void
  className?: string
}

const PercentFilterItem = ({ item, onItemUpdate, className }: Props) => {
  const toggleOption = (option: CheckboxFilterOption) => {
    const updatedCategory = jsonClone(item) as FilterCategory
    const options = updatedCategory.options as CheckboxFilterOption[]
    const index = options.findIndex((x) => x.value === option.value)
    options[index].selected = !options[index].selected

    onItemUpdate(updatedCategory)
  }

  return (
    <div className={className}>
      {item.options.map((option) => (
        <div key={(option as CheckboxFilterOption).key}>
          <CheckboxFilterItem
            option={option as CheckboxFilterOption}
            selected={(option as CheckboxFilterOption).selected ?? false}
            onClick={() => toggleOption(option as CheckboxFilterOption)}
            className="pl-3 mt-3 mb-1 sm:my-1 sm:pl-0"
          />
        </div>
      ))}
    </div>
  )
}

export default PercentFilterItem
